var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "big" },
    [
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-around" } },
        [
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 12, md: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  {
                    staticClass: "grid-content",
                    on: { click: _vm.totalOrderClick },
                  },
                  [
                    _c("div", { staticClass: "lable" }, [
                      _vm._v("今日收款总额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.todayDeposit)),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 12, md: 6 } },
            [
              _c("el-card", [
                _c(
                  "div",
                  {
                    staticClass: "grid-content",
                    on: { click: _vm.successRateClick },
                  },
                  [
                    _c("div", { staticClass: "lable" }, [
                      _vm._v("已结算剩余金额"),
                    ]),
                    _c("span", { staticClass: "value" }, [
                      _vm._v(_vm._s(_vm.lastSettlementAmount)),
                    ]),
                  ]
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }